import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useEffect, useState } from "react";

export default function PurchasePopup({ show, handleClose, handleSubmit }) {
    const { PopupStore } = useStores();
    const [coins, setCoins] = useState(JSON.parse(localStorage.getItem("user"))?.coins);
    
  return useObserver(() => (
    <>
      {PopupStore.PurchasePopup && (
        <div className=" absoulte h-screen w-screen overflow-y-auto z-[500] rounded fixed bottom-0 left-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40  shadow-lg gil-reg overflow-x-hidden no-scrollbar">
          {/* absolute w-screen gil-reg h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40  */}
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-lg overflow-y-hidden items-center md:w-[30%] lg:w-[60%] w-[80%] h-[45%] md:h-[35%] lg:h-[50%] m-auto shadow-lg  no-scrollbar"
          >
            <div className="flex flex-col justify-around  h-full p-5 w-[100%] md:w-[100%] lg:[100%] border ">
              <p className="font-semibold opacity-50">
                You have {coins}{" "}
                credits in your account. Would you like to continue with
                creating a new job post or would you like to purchase more
                credits?
              </p>
              <div className="flex justify-between items-center">
                <button
                  onClick={() => {
                    handleSubmit();
                    handleClose();
                  }}
                  className="gil-reg text-primary bg-white border border-primary px-4 py-2 rounded-lg"
                >
                  Continue
                </button>
                <button
                  onClick={() => {
                    PopupStore.setPaymentGateway(true);
                    handleClose();
                  }}
                  className="gil-reg text-white bg-primary px-4 py-2 rounded-lg"
                >
                  Purchase
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ));
}
